import './OrgSDGPieWidget.css';

import React from 'react';
import { useLoginContext } from '../../../../../App';
import useB2BTranslation from '../../../../b2b-common/hooks/useB2BTranslation';
import usePlansData from '../../../../b2b-plans/hooks/usePlansData';
import usePlansImpact from '../../../../b2b-frameworks/hooks/usePlansImpact';
import { Box } from '@mui/material';
import ORGANIZATION_SDGS_PIECHART_WidgetLayout from './ORGANIZATION_SDGS_PIECHART_WidgetLayout';

const OrgSDGPieWidget = ({ widget }) => {
    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-reporting');
    const { organizationPlansData } = usePlansData(50);
    const { plansImpact: orgImpact, isSearching } = usePlansImpact('generic', 2, (organizationPlansData?.content || []).map(plan => plan.plan.planUUID));

    if (!organizationPlansData || !orgImpact || orgImpact.length === 0) {
        return null;
    }

    if (isSearching) {
        return (
            <Box className={'OrgSDGPieWidget-loading'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <Box className={'OrgSDGPieWidget-loading-text'}>
                    {t('Loading...')}
                </Box>
            </Box>
        );
    }

    const data = orgImpact.map((impactItem, index) => {
        return {
            levelN_ItemId: impactItem.dtoReference.theOne.levelN_ItemId,
            indicatorUUIDs: impactItem.dtoReference.theMany.map(indicator => indicator.indicatorUUID),
        };
    });

    const size = widget?.widgetConfig?.extraFields?.size || 420;

    return (
        <Box className={'OrgSDGPie-container'} height={`${size}px`} width={`${size}px`}
            display={'flex'} justifyContent={'center'} alignItems={'center'}
        >
            <ORGANIZATION_SDGS_PIECHART_WidgetLayout
                data={data}
                size={size}
                locale={widget?.widgetConfig?.extraFields?.locale || loginData.locale}
            />
        </Box>
    );

}

export default OrgSDGPieWidget;